import React, { useState } from "react";
import SelectBox from "../SelectBox";
import TextBox from "../TextBox";
import DATA_PRODUCTS from "../DATA_PRODUCTS";
import DATA_COUNTRY_CODE from "../DATA_COUNTRY_CODE";
import DATA_PLATFORM from "../DATA_PLATFORM";
import DATA_PARTNERS from "../DATA_PARTNERS";

import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(AppTheme => ({
  textInputStyle: {
    border: "none",
    background:
      "linear-gradient(180deg, rgba(0, 0, 0, .2) 0%, rgba(0, 0, 0, .6) 100%)",
    display: "block",
    // this is the helper text color
    "& .Mui-error": {
      color: "#cc0000"
    }
  }
}));

// const Inputs = (props, { inputsCheckButtonPressed, inputsCheckButtonPressedOnce }) => {
const Inputs = props => {
  const { inputsCheckButtonPressed, inputsCheckButtonPressedOnce } = props;
  //const {client} = inputValues
  // let DATA_PRODUCTS_ARRAY = DATA_PRODUCTS.data; //* instead of 1:1 were going to map it out and evaluate the data to handle toggling isDisabled, see below
  let DATA_PARTNER_ARRAY = DATA_PARTNERS.data;
  let DATA_COUNTRY_CODE_ARRAY = DATA_COUNTRY_CODE.data;
  let DATA_PLATFORM_ARRAY = DATA_PLATFORM.data;
  const DATA_PRODUCTS_ARRAY = DATA_PRODUCTS.data.map(product => ({
    ...product,
    label: product.label,
    value: product.value,
    isDisabled: !product.productAvailableForProgrammatic //* or for Direct over in inputs.js
  }));

  const [clientError, setClientError] = useState(true);
  const [campaignError, setCampaignError] = useState(false);

  const handleAnyInputsChange = (name, value) => {
    // for mui textfield
    //props.handleAnyInputsChange(e.target.name, e.target.value);

    // for my textfields
    props.handleAnyInputsChange(name, value);
  };

  const classes = useStyles();

  Object.keys(props).forEach(key => {
    // console.log(`progInputs.js test here: props.${key}:`, props[key]);
  });

  return (
    <div>
      <div className="inputsFullPageColumn">
        <div className="inputsColRow">
          <TextBox
            value={props.inputValues.creativeID}
            label="CREATIVE ID:"
            varID="creativeID"
            handleAnyInputsChange={handleAnyInputsChange}
            inputsCheckButtonPressed={inputsCheckButtonPressed}
            inputsCheckButtonPressedOnce={inputsCheckButtonPressedOnce}
          />
        </div>

        <div className="inputsColRow">
          <SelectBox
            value={props.inputValues.partner}
            isError={false}
            options={DATA_PARTNER_ARRAY}
            label="PARTNER:"
            varID="partner"
            handleAnyInputsChange={handleAnyInputsChange}
            inputsCheckButtonPressed={inputsCheckButtonPressed}
          />
          <SelectBox
            value={props.inputValues.countryCode}
            isError={false}
            options={DATA_COUNTRY_CODE_ARRAY}
            label="COUNTRY/LANGUAGE:"
            varID="countryCode"
            handleAnyInputsChange={handleAnyInputsChange}
            inputsCheckButtonPressed={inputsCheckButtonPressed}
          />
          <SelectBox
            value={props.inputValues.product}
            isError={false}
            options={DATA_PRODUCTS_ARRAY}
            label="PRODUCT:"
            varID="product"
            handleAnyInputsChange={handleAnyInputsChange}
            inputsCheckButtonPressed={inputsCheckButtonPressed}
          />
        </div>
      </div>
    </div>
  );
};

export default Inputs;
